import type PaymentMethodEntryViewStates from '../../../shared/types/capabilities/PaymentMethodEntryViewStates';

const getShowLoaderDefaultValue = (
  viewState: PaymentMethodEntryViewStates,
  isInitializing: boolean,
) =>
  viewState === 'unified_payment_method_form' || isInitializing;

export default getShowLoaderDefaultValue;
